import { createElement } from 'react';
import { Area, AreaPolygons, Areas, Team, TeamPolygons, Teams } from '../pages';
import { settings } from '../settings';
import { urlTo } from '../utils';
const routes = () => {
    const routes = [
        {
            path: settings.routePrefix,
            children: [
                {
                    id: 'areas',
                    index: true,
                    element: createElement(Areas),
                },
                {
                    path: 'area/:areaId',
                    children: [
                        {
                            index: true,
                            element: createElement(Area),
                        },
                        {
                            path: 'polygons',
                            element: createElement(AreaPolygons),
                        },
                    ],
                },
                {
                    path: 'teams',
                    element: createElement(Teams),
                },
                {
                    path: 'team/:teamId',
                    children: [
                        {
                            index: true,
                            element: createElement(Team),
                        },
                        {
                            path: 'polygons',
                            element: createElement(TeamPolygons),
                        },
                    ],
                },
            ],
        },
    ];
    urlTo.addRoutes(routes, settings.routePrefix);
    return routes;
};
export { routes };
